import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Button from '@sorare/core/src/atoms/buttons/Button';
import { SorareLogo } from '@sorare/core/src/atoms/icons/SorareLogo';
import StarBall from '@sorare/core/src/atoms/icons/StarBall';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import Dialog from '@sorare/core/src/components/dialog';
import { DrukWide40 } from '@sorare/core/src/components/marketing/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

import challengesDialogBg from './assets/challenges-dialog-bg.png';
import introducing from './assets/introducing.svg';

const Root = styled.div`
  height: 100%;
  padding: var(--quadruple-unit) var(--double-unit);
  background: linear-gradient(
      0deg,
      var(--c-neutral-100) 10%,
      rgba(var(--c-rgb-neutral-100), 0.2) 60%
    ),
    url(${challengesDialogBg});
  background-position: center;
  background-repeat: no-repeat;
`;
const SpaceBetweenVertical = styled(Vertical)`
  height: 100%;
  justify-content: space-between;
`;
const CloseButtonContainer = styled.div`
  position: absolute;
  top: var(--double-unit);
  right: var(--double-unit);
`;
const Introducing = styled.img`
  width: 180px;
`;
const StyledDrukWide40 = styled(DrukWide40)`
  text-transform: uppercase;
`;
type Props = { open: boolean; onClose: () => void };

export const ChallengesIntroduceDialog = ({ open, onClose }: Props) => {
  return (
    <Dialog maxWidth="sm" open={open} onClose={onClose} hideHeader>
      {({ CloseButton }) => (
        <Root>
          <CloseButtonContainer>
            <CloseButton onClose={onClose} />
          </CloseButtonContainer>
          <SpaceBetweenVertical gap={5} center>
            <Vertical gap={5} center>
              <Introducing src={introducing} alt="" />
              <Vertical center>
                <Horizontal>
                  <StarBall color="var(--c-neutral-1000)" />
                  <SorareLogo />
                </Horizontal>
                <StyledDrukWide40>
                  <FormattedMessage {...glossary.challenges} />
                </StyledDrukWide40>
              </Vertical>
              <BodyM as="p" className="text-center">
                <FormattedMessage
                  id="Challenges.ChallengesIntroduceDialog.textV2"
                  defaultMessage="Complete Challenges to unlock badges, gain Manager Points, and level up in the game."
                />
              </BodyM>
            </Vertical>
            <Button size="medium" color="primary" onClick={onClose}>
              <FormattedMessage
                id="Challenges.ChallengesIntroduceDialog.letsGo"
                defaultMessage="Let's Go!"
              />
            </Button>
          </SpaceBetweenVertical>
        </Root>
      )}
    </Dialog>
  );
};
